(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DriverJsFunction', DriverJsFunction);

    DriverJsFunction.$inject = ['CompanyInfoQuery', 'ActivityTypeInfoCustom', '$localStorage', '$timeout', '$q'];

    function DriverJsFunction(CompanyInfoQuery, ActivityTypeInfoCustom, $localStorage, $timeout, $q) {
        var servant_label = "پرسنل";

        var drive = function () {
            var driverObj = null;
            var driver = window.driver.js.driver;
            CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {
                if (company != null && company != undefined) {
                    ActivityTypeInfoCustom.getActivityTypeInfoByType(company.activityType).query(function (result) {
                        if (result.servantListTitle) {
                            servant_label = result.servantListTitle
                        }
                        driverObj = driver({
                            nextBtnText: 'بعدی',
                            doneBtnText: 'تمام',
                            closeBtnText: 'بستن',
                            prevBtnText: 'قبلی',
                            showProgress: true,
                            onPopoverRender: function (popover) {
                                const dontShowBtn = document.createElement("button");
                                dontShowBtn.textContent = "دیگه نشان نده";
                                dontShowBtn.className = "driverjs-dont-show-again-btn";
                                dontShowBtn.style.padding = "6px 10px";
                                dontShowBtn.addEventListener("click", function () {
                                    $localStorage.driverjs_dontShowAgain = "true"
                                    driverObj.destroy();
                                })

                                const footer = popover.footer
                                if (footer) {
                                    footer.appendChild(dontShowBtn);
                                }
                            },
                            steps: [
                                {
                                    popover: {
                                        title: 'به پلنوین خوش آمدید',
                                        description: 'با پلنوین می‌تونید همه رزروها، مشتری‌ها و خدماتتون رو تو یه پلتفرم ساده و کاربردی مدیریت کنید' +
                                            'برای آشنایی با بخش‌های مختلف پنل، همراه ما باشید.',
                                        progressText: 'مرحله ۱ از ۱۶',
                                    }
                                },
                                {
                                    element: '#pl-profile',
                                    popover: {
                                        description: 'با پلنوین می‌تونید همه رزروها، مشتری‌ها و خدماتتون رو تو یه پلتفرم ساده و کاربردی مدیریت کنیدبا کلیک روی این آیکون می‌تونید به اطلاعات پروفایل کاربری، تمدید اشتراک و خرید بسته پیامکی دسترسی داشته باشید. همچنین اطلاعات حقیقی و حقوقی در این بخش قابل تنظیم هستن.',
                                        progressText: 'مرحله ۲ از ۱۶',
                                        side: "right",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#pl-my-site',
                                    popover: {
                                        description: 'با کلیک روی این آیکون، وارد سایت اختصاصی خودتون می‌شید.' +
                                            ' جایی که مشتری‌ها می‌تونن آنلاین رزرو انجام بدن و خدمات شما رو ببینن. حالا می‌تونید ببینید سایتتون چقدر شیک‌تر شده!',
                                        progressText: 'مرحله ۳ از ۱۶',
                                        side: "right",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#pl-help',
                                    popover: {
                                        description: ' اگر به هر راهنمایی نیاز داشتید، از این بخش می‌تونید به واحد پشتیبانی پلنوین یا آموزش ها دسترسی داشته باشید و سوالات یا مشکلاتتون رو مطرح کنید. پشتیبانی پلنوین هر زمانی که به کمک نیاز داشتید در کنارتونه. ',
                                        progressText: 'مرحله ۴ از ۱۶',
                                        side: "right",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#home-li svg',
                                    popover: {
                                        description: 'در این صفحه می‌تونید همیشه یه دید سریع از اوضاع کسب‌و‌کارتون داشته باشید، خلاصه ای از وضعیت رزروها رو مشاهده کنید و در صورت نیاز ویرایششون کنید. ',
                                        progressText: 'مرحله ۵ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#servant-li svg',
                                    popover: {
                                        description: 'اینجا می‌تونید ' + servant_label + ' جدید اضافه کنید، ساعت کاری‌شون رو تنظیم کنید یا اطلاعات‌شون رو ویرایش کنید.',
                                        progressText: 'مرحله ۶ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#service-li svg',
                                    popover: {
                                        description: 'در این بخش می‌تونید خدمات جدید تعریف کنید یا موارد قبلی رو ویرایش کنید.' +
                                            ' تعرفه، مدت‌زمان و توضیحات هر خدمت به‌راحتی قابل تغییر هست.',
                                        progressText: 'مرحله ۷ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#event-li svg',
                                    popover: {
                                        description: 'میتونید کارگاه یا رویداد اموزشی برگزار کنید. بخش رویدادها مخصوص برنامه‌هایی‌ هست که فقط یک‌بار و در یک تاریخ خاص برگزار میشود . اینجا می‌تونید تنظیم و مدیریتشون کنید.',
                                        progressText: 'مرحله ۸ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#reserve-list-li svg',
                                    popover: {
                                        description: 'در این بخش می‌تونید تمام رزروهایی که ثبت‌شدن رو مدیریت کنید. همچنین امکان ثبت نوبت به صورت پذیرش حضوری یا تلفنی به وجود داره.',
                                        progressText: 'مرحله ۹ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#calendar-li svg',
                                    popover: {
                                        description: 'تقویم کامل رزروها اینجاست!' +
                                            ' زمان‌های آزاد، رزروشده و تعطیلی‌ها رو به‌صورت تصویری روی تقویم ببینید.' +
                                            ' حتی می‌تونید استثناهایی مثل مرخصی یا مناسبت خاص رو هم اینجا وارد کنید.',
                                        progressText: 'مرحله ۱۰ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#invoice-li svg',
                                    popover: {
                                        description: 'در این قسمت می‌تونید فاکتور جدید ثبت کنید و سوابق فیش‌های فروش قبلی رو بررسی کنید.',
                                        progressText: 'مرحله ۱۱ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#customer-li svg',
                                    popover: {
                                        description: 'اینجا پرونده کامل مشتریان شما قرار داره؛ یک سیستم CRM برای مدیریت بهتر ارتباط با مشتریان.' +
                                            'می‌تونید مشتری جدید اضافه کنید، اون‌ها رو دسته‌بندی کنید(مثلا مشتریان VIP و نقره‌ای)، فرم‌های دریافتی و تمامی اطلاعات ثبت‌شده رو مشاهده کنید و به سوابق رزرو هر مشتری دسترسی داشته باشید.',
                                        progressText: 'مرحله ۱۲ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#report-li svg',
                                    popover: {
                                        description: 'در این بخش می‌تونید گزارش‌هایی با فرمت اکسل از کسب‌وکارتون دریافت کنید، مثل جزئیات رزروها و لیست مشتریان.',
                                        progressText: 'مرحله ۱۳ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#finance-li svg',
                                    popover: {
                                        description: 'در بخش مالی پنل به اطلاعات تمامی پرداخت‌هایی که  از طریق درگاه پرداخت پلنوین انجام شدن دسترسی دارید.' +
                                            'درخواست تسویه‌حساب هم از همین قسمت انجام می‌شه.',
                                        progressText: 'مرحله ۱۴ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#setting-li svg',
                                    popover: {
                                        description: 'تنظیمات حرفه‌ای کسب‌وکارتون در این بخش قرار داره!' +
                                            'اینجا می‌تونید تنظیمات کسب‌وکار، تنظیمات مالی و امکانات ویژه مثل ایجاد کد تخفیف، تنطیم پیامک‌های خودکار و محاسبه کمیسون پرسنل رو مدیریت کنید.',
                                        progressText: 'مرحله ۱۵ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    popover: {
                                        description: 'تبریک می‌گم! با قسمت‌های مختلف پنل آشنا شدید.' +
                                            'حالا می‌تونید کسب‌وکارتون رو با پلنوین چندین پله ارتقا بدید. اگه بازم به راهنماییم نیاز  داشتید از منوی راهنما می‌تونید بهم دسترسی داشته باشید.',
                                        progressText: 'مرحله ۱۶ از ۱۶',
                                    }
                                }
                            ]
                        });
                        driverObj.drive();

                    })
                }
            })
        }
        if (!$localStorage.driverjs_dontShowAgain && window.innerWidth >= 768) {
            $timeout(drive, 5000);
        }

        return {
            drive: drive
        };
    }
})();